import * as ROUTES from '../routes';

//const permissions = ['can_view_crypto_transaction','can_view_crypto_manager','can_view_crypto_trade'];
const Navigations = [
    {
        
        title: "Crypto",
        icon: "mdi-database-outline",
        mini: false,
        to: ROUTES.CRYPTO_TRADES,
         
        permissions: ['can_view_crypto'],
        subNav: [
            {
                title: "transactions",
                to: ROUTES.CRYPTO_transactionS,
                icon: 'mdi-wallet-giftcard',
                permissions: ['can_view_crypto_transaction'],
            },
            {
                title: "Wallet manager",
                to: ROUTES.CRYPTO_MANAGER,
                icon: 'mdi-chart-bar',
                permissions: ['can_view_crypto_manager'],
            },
            {
                title: "Crypto Trades",
                to: ROUTES.CRYPTO_TRADES,
                icon: 'mdi-chart-bar',
                permissions: ['can_view_crypto_trade'],
            },
        ],
    },
   
]

export default Navigations